import Vue from "vue";
import App from "./App.vue";
import vuetify from "./plugins/vuetify";
import common from "./plugins/common";
import my from "./plugins/my";

import router from "./router";
import store from "./store";
import axios from "axios";
import config from "./config";
import classStyle from "./styles/ClassStyle";
import globalStyle from "./styles/GlobalStyle.module.css";

Vue.config.productionTip = false;
Vue.prototype.$liff = window.liff;

Vue.prototype.$ajax = axios;
Vue.prototype.$spec = {
  dialog_standard_max_width: 580,
  snakebar_timeout: 2000
};
Vue.prototype.$config = config;
Vue.prototype.$classStyle = classStyle;
Vue.prototype.$globalStyle = globalStyle;

Vue.use(common);
Vue.use(my);

new Vue({
  vuetify,
  router,
  store,
  render: h => h(App)
}).$mount("#app");
